import { useEffect } from 'react'
import BottomSheetContent from '../../BottomSheetContent'
import { trackEvent } from '../../../../utils/appBridge'
import { EventNames } from '../../../../types/misc.types'
import { AutopayPaymentMode } from '../../../../types/mf-execution.types'
import { roundOffAndFormatNumberWithCurrency } from '../../../../utils/utils'

export function SetupAutoPayMaxLimitBottomSheet({
  onDismiss,
  mode,
  maxLimit,
  ScreenName,
}: {
  onDismiss: () => void
  mode: AutopayPaymentMode
  maxLimit: number
  ScreenName: string
}) {
  const isUpiMode = mode === 'UPI'
  const maxLimitLabel = roundOffAndFormatNumberWithCurrency(maxLimit)
  const maxLimitDescription = isUpiMode
    ? `${maxLimitLabel} is the maximum allowed by UPI AutoPay.`
    : `${maxLimitLabel} is the maximum allowed by Netbanking AutoPay.`

  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: 'Max. limit',
        ScreenName,
      },
    })
  }, [ScreenName])

  return (
    <BottomSheetContent onDismiss={onDismiss} bottomSheetBodyClassName='!px-5 !pb-2'>
      <h2 className={`text-[22px] font-normal mb-4`}>
        Only SIP amount will be charged. <br /> {maxLimitDescription}
      </h2>

    </BottomSheetContent>
  )
}
